import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Switch, Route } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import AreaOfStudyList from "./AreaOfStudyList";
import AreaOfStudyDetail from "./AreaOfStudyDetail";
import AreaOfStudyEdit from "./AreaOfStudyEdit";
import SEO from "../../../UI/SEO/SEO";
export const getAreaOfStudyBasePath = () => getAdminBasePath() + "/areaOfStudy";
export const getAreaOfStudyBaseRoute = () => getAdminBaseRoute() + "/areaOfStudy";
export const getAreaOfStudyIndexRoute = () => getAreaOfStudyBaseRoute();
export const getAreaOfStudyIndexPath = () => getAreaOfStudyBasePath();
export const getAreaOfStudyDetailPath = (id) => getAreaOfStudyBasePath() + `/${id}`;
export const getAreaOfStudyDetailRoute = () => getAreaOfStudyBaseRoute() + "/:id";
export const getAreaOfStudyEditPath = (id) => getAreaOfStudyBasePath() + `/edit/${id}`;
export const getAreaOfStudyEditRoute = () => getAreaOfStudyBaseRoute() + "/edit/:id";
const AdminAreaOfStudyRoutes = () => {
    return (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Area Of Study" }), _jsxs(Switch, { children: [_jsx(Route, { component: AreaOfStudyEdit, path: getAreaOfStudyEditRoute() }), _jsx(Route, { component: AreaOfStudyDetail, path: getAreaOfStudyDetailRoute() }), _jsx(Route, { component: AreaOfStudyList, path: getAreaOfStudyIndexRoute() })] })] }));
};
export default AdminAreaOfStudyRoutes;
